import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class VendorService {

  constructor(private http: HttpClient) { }

  saveVendor(id: any, payload: any) {
    if (id) {
      return this.http.put(urls.API_URL + urls.QUICKBOOK + '/' + urls.VENDORS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.QUICKBOOK + '/' + urls.VENDORS, payload)
      .pipe(catchError(errorHandl));
  }

  getVendors(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.VENDORS, { params })
      .pipe(catchError(errorHandl));
  }

  getVendorById(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.VENDORS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  syncVendor(vendorId: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.VENDORS + `/${vendorId}/${urls.SYNC}`, { params })
      .pipe(catchError(errorHandl));
  }

  syncAllVendors() {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.VENDORS + `/${urls.SYNC}`)
      .pipe(catchError(errorHandl));
  }
}
